import { Component, OnInit, OnDestroy } from '@angular/core';
import { AuthService } from '../../infrastructure/services/auth.service';
import { SxSecurityService } from '../../infrastructure/services/sxSecurity.service';
import { Router, ActivatedRoute } from '@angular/router';
import { StyleService } from 'app/infrastructure/services/style.service';
import {
  ConfigService,
  RootConfigurationItem,
} from 'app/infrastructure/services/config.service';

@Component({
  selector: 'app-desktop',
  templateUrl: './desktop.component.html',
  // styleUrls: ['./desktop.component.css'],
})
export class DesktopComponent implements OnInit, OnDestroy {
  itemOver: string;

  currentUser = this.authService.currentUser;
  rootItems: RootConfigurationItem[];

  constructor(
    public authService: AuthService,
    public securityService: SxSecurityService,
    public router: Router,
    public aRoute: ActivatedRoute,
    private styleService: StyleService,
    private rootConfigService: ConfigService
  ) {}

  ngOnInit() {
    this.styleService.addStyle(
      'DesktopComponent',
      require('./desktop.component.css')
    );
    document
      .getElementById('container-principal')
      .classList.remove('container');
    document.getElementById('breadcrumb-principal').style.display = 'none';
    this.rootConfigService.getRootConiguration().subscribe((x) => {
      this.rootItems = x;
    });
  }

  logout() {
    this.securityService.logout();
  }
  ngOnDestroy() {
    this.styleService.removeStyle('DesktopComponent');
    document.getElementById('container-principal').classList.add('container');
    document.getElementById('breadcrumb-principal').style.display = 'block';
  }
}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/desktop/desktop.component.ts